import { Component } from '@angular/core';
import { WhatsappForBusinessService } from '../../../../../services/whatsapp-for-business.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { AppConfig } from '../../../../../app.config';
import { Router } from '@angular/router';

@Component({
  selector: 'app-whatsapp-templates',
  templateUrl: './whatsapp-templates.component.html',
  styleUrls: ['./whatsapp-templates.component.scss']
})
export class WhatsappTemplatesComponent {

  public busy: boolean = false;
  public messageTemplates : any = [];
  public selectedMessageTemplate : any = null;
  public destinationNumber : string = null;
  public freeText : string = null;
  public partner: any = {};
  public isWorkshop = true;
  public isRentals = false;

  constructor(
    private whatsappForBusinessService : WhatsappForBusinessService,
    private helpersService : HelpersService,
    public appConfig : AppConfig,
    private router: Router
  ){

  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/whatsapp-integration'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }
    this.partner = this.helpersService.getPartnerData();
    this.getMessageTemplates();    
  }

  getMessageTemplates(){
    this.busy = true;
    this.whatsappForBusinessService.getWhatsAppMessageTemplates(this.helpersService.getPartnerId()).subscribe(res=>{
      if(res && res.length >0){
        res.forEach(element => {
          if(element.rejectReason){
            try{
              element.rejectReason = JSON.parse(element.rejectReason);
            }catch(r){

            }
          }
        });
      }
      this.messageTemplates = res;
      this.busy = false;
    },err=>{
      this.busy = false;
    })
  }

  getObjectString(object) {
    return JSON.stringify(object);
  }

  // syncTemplates(){
  //   this.busy = true;
  //   this.whatsappForBusinessService.syncTemplatesToWhatsapp(this.helpersService.getPartnerId()).subscribe(res=>{
  //     this.busy = false;
  //   },err=>{
  //     this.busy = false;
  //   });
  // }

}
